export default __webpack_public_path__ + "static/media/times.842f5206.svg";